import { getSurveysOptions, getSurveyOptions } from "@pulse/api/queryApi";
import { completeSurvey } from "@pulse/api/surveyApi";
import InfoModal from "@pulse/components/Modal/Templates/InfoModal";
import { useModal } from "@pulse/hooks/contextHooks";
import { queryClient } from "@pulse/queryClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import ActionButton from "./ActionButton";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "frontend-components";

export default function CompleteSurvey({ surveyId }: { surveyId: number }) {
    const { openModal, closeModal } = useModal();
    const { data: survey } = useQuery(getSurveyOptions({ surveyId }));
    const { t } = useTranslation();
    const completeMutation = useMutation({
        mutationFn: () => completeSurvey({ surveyId: surveyId }),
        onSuccess: () => {
            queryClient.invalidateQueries(getSurveyOptions({ surveyId: surveyId }));
            queryClient.invalidateQueries(
                getSurveysOptions({ pulseInstanceId: survey?.pulseInstanceId || 0 }),
            );
            closeModal();
        },
    });
    return (
        <ActionButton
            label={t("responseOverview.labelComplete")}
            primary
            onClick={() =>
                openModal({
                    children: (
                        <InfoModal
                            type="warning"
                            text={t("responseOverview.completeSurveyWarning")}
                            subText={t("responseOverview.completeSurveySubText")}
                            customButtons={
                                <>
                                    <Button
                                        disabled={completeMutation.isPending}
                                        onClick={() => closeModal()}
                                    >
                                        {t("common.cancel")}
                                    </Button>
                                    <Button
                                        disabled={completeMutation.isPending}
                                        onClick={() => completeMutation.mutate()}
                                        variant="submit"
                                    >
                                        {t("common.complete")}
                                    </Button>
                                </>
                            }
                        />
                    ),
                })
            }
        >
            <FontAwesomeIcon icon={faCheck} size="xl" />
        </ActionButton>
    );
}
